import { BaseScene } from './BaseScene';
import { MultiplierBoard } from './components/MultiplierBoard';

export class MultiplierScene extends BaseScene {
  multiplier: any;
  multiplierBoard: any;
  drawResult: any;
  constructor() {
    super('MultiplierScene', true);
  }

  preload() {
    const drawResult = window._po_gm.config.drawResult;
    this.multiplier = parseInt(drawResult[drawResult.length - 1]);
    this.drawResult = window._po_gm.config.drawResult;
  }

  createBody() {
    const logo = this.getLogo();
    logo.setTexture('money_roll_logo_superbonus');
    logo.setY(this.screenHeight / 2 - 270);

    this.addMultiplierBoard();
  }

  addMultiplierBoard() {
    this.multiplierBoard = new MultiplierBoard(this, this.screenWidth, this.screenHeight, this.multiplier, this.drawResult);
  }

  // cleanUpListeners() {
  //   this.multiplierBoard.cleanUpListeners();
  // }

  pauseTimer() {
    this.multiplierBoard.pauseTimer();
  }

  resumeTimer() {
    this.multiplierBoard.resumeTimer();
  }
  emitEvent() {
    this.events.emit('multiplierNumberAnimationEnded');
  }
}
